import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Phone, Menu, X, ArrowRight } from "lucide-react";
import { Logo } from "./Logo";
import { SITE } from "../data/site";

const links = [
  { to: "/pricing", label: "Pricing" },
  { to: "/payroll-services", label: "States we serve" },
  { to: "/blog", label: "Resources" },
  { to: "/about", label: "About" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-300 ${
        scrolled ? "bg-white/90 backdrop-blur-md border-slate-200" : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" aria-label="ABSLpay home" data-testid="nav-logo">
          <Logo />
        </Link>
        <nav className="hidden lg:flex items-center gap-8" aria-label="Main">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/ /g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-semibold transition-colors ${isActive ? "text-emerald-700" : "text-slate-700 hover:text-slate-900"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href={`tel:${SITE.phone}`}
            data-testid="nav-phone-cta"
            className="flex items-center gap-2 text-sm font-bold text-slate-900 hover:text-emerald-700 transition-colors"
          >
            <Phone size={15} className="text-emerald-600" />
            {SITE.phoneDisplay}
          </a>
          <Link
            to="/contact"
            data-testid="nav-get-quote-btn"
            className="group inline-flex items-center gap-2 rounded-full bg-slate-900 text-white text-sm font-bold px-5 py-2.5 hover:bg-emerald-700 transition-colors"
          >
            Get a free quote
            <ArrowRight size={15} className="transition-transform group-hover:translate-x-0.5" />
          </Link>
        </nav>
        <button
          className="lg:hidden p-2 text-slate-900"
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <nav className="lg:hidden bg-white border-t border-slate-200 px-6 py-6 space-y-4" aria-label="Mobile">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} className="block text-base font-semibold text-slate-800">
              {l.label}
            </NavLink>
          ))}
          <a href={`tel:${SITE.phone}`} className="block text-base font-bold text-slate-900">
            {SITE.phoneDisplay}
          </a>
          <Link
            to="/contact"
            data-testid="nav-mobile-quote-btn"
            className="inline-flex items-center gap-2 rounded-full bg-slate-900 text-white text-sm font-bold px-5 py-3"
          >
            Get a free quote <ArrowRight size={15} />
          </Link>
        </nav>
      )}
    </header>
  );
};
